module.exports = __webpack_public_path__ + "img/cancercouncil-sa.d60d1c5.png";